var Ye = (r) => {
  throw TypeError(r);
};
var Ze = (r, t, e) => t.has(r) || Ye("Cannot " + e);
var Je = (r, t, e) => (Ze(r, t, "read from private field"), e ? e.call(r) : t.get(r)), Qe = (r, t, e) => t.has(r) ? Ye("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(r) : t.set(r, e), Ae = (r, t, e, s) => (Ze(r, t, "write to private field"), s ? s.call(r, e) : t.set(r, e), e);
import { B as P } from "./events-CMiHMbSn.js";
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const ue = globalThis, V = ue.ShadowRoot && (ue.ShadyCSS === void 0 || ue.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, Oe = Symbol(), et = /* @__PURE__ */ new WeakMap();
let vt = class {
  constructor(t, e, s) {
    if (this._$cssResult$ = !0, s !== Oe) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t, this.t = e;
  }
  get styleSheet() {
    let t = this.o;
    const e = this.t;
    if (V && t === void 0) {
      const s = e !== void 0 && e.length === 1;
      s && (t = et.get(e)), t === void 0 && ((this.o = t = new CSSStyleSheet()).replaceSync(this.cssText), s && et.set(e, t));
    }
    return t;
  }
  toString() {
    return this.cssText;
  }
};
const Bt = (r) => new vt(typeof r == "string" ? r : r + "", void 0, Oe), Z = (r, ...t) => {
  const e = r.length === 1 ? r[0] : t.reduce((s, i, n) => s + ((c) => {
    if (c._$cssResult$ === !0) return c.cssText;
    if (typeof c == "number") return c;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + c + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(i) + r[n + 1], r[0]);
  return new vt(e, r, Oe);
}, Kt = (r, t) => {
  if (V) r.adoptedStyleSheets = t.map((e) => e instanceof CSSStyleSheet ? e : e.styleSheet);
  else for (const e of t) {
    const s = document.createElement("style"), i = ue.litNonce;
    i !== void 0 && s.setAttribute("nonce", i), s.textContent = e.cssText, r.appendChild(s);
  }
}, tt = V ? (r) => r : (r) => r instanceof CSSStyleSheet ? ((t) => {
  let e = "";
  for (const s of t.cssRules) e += s.cssText;
  return Bt(e);
})(r) : r;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { is: qt, defineProperty: Gt, getOwnPropertyDescriptor: Xt, getOwnPropertyNames: Yt, getOwnPropertySymbols: Zt, getPrototypeOf: Jt } = Object, L = globalThis, st = L.trustedTypes, Qt = st ? st.emptyScript : "", _e = L.reactiveElementPolyfillSupport, ie = (r, t) => r, pe = { toAttribute(r, t) {
  switch (t) {
    case Boolean:
      r = r ? Qt : null;
      break;
    case Object:
    case Array:
      r = r == null ? r : JSON.stringify(r);
  }
  return r;
}, fromAttribute(r, t) {
  let e = r;
  switch (t) {
    case Boolean:
      e = r !== null;
      break;
    case Number:
      e = r === null ? null : Number(r);
      break;
    case Object:
    case Array:
      try {
        e = JSON.parse(r);
      } catch {
        e = null;
      }
  }
  return e;
} }, Pe = (r, t) => !qt(r, t), it = { attribute: !0, type: String, converter: pe, reflect: !1, useDefault: !1, hasChanged: Pe };
var ft, pt;
(ft = Symbol.metadata) != null || (Symbol.metadata = Symbol("metadata")), (pt = L.litPropertyMetadata) != null || (L.litPropertyMetadata = /* @__PURE__ */ new WeakMap());
let B = class extends HTMLElement {
  static addInitializer(t) {
    var e;
    this._$Ei(), ((e = this.l) != null ? e : this.l = []).push(t);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(t, e = it) {
    if (e.state && (e.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(t) && ((e = Object.create(e)).wrapped = !0), this.elementProperties.set(t, e), !e.noAccessor) {
      const s = Symbol(), i = this.getPropertyDescriptor(t, s, e);
      i !== void 0 && Gt(this.prototype, t, i);
    }
  }
  static getPropertyDescriptor(t, e, s) {
    var c;
    const { get: i, set: n } = (c = Xt(this.prototype, t)) != null ? c : { get() {
      return this[e];
    }, set(u) {
      this[e] = u;
    } };
    return { get: i, set(u) {
      const d = i == null ? void 0 : i.call(this);
      n == null || n.call(this, u), this.requestUpdate(t, d, s);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(t) {
    var e;
    return (e = this.elementProperties.get(t)) != null ? e : it;
  }
  static _$Ei() {
    if (this.hasOwnProperty(ie("elementProperties"))) return;
    const t = Jt(this);
    t.finalize(), t.l !== void 0 && (this.l = [...t.l]), this.elementProperties = new Map(t.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(ie("finalized"))) return;
    if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(ie("properties"))) {
      const e = this.properties, s = [...Yt(e), ...Zt(e)];
      for (const i of s) this.createProperty(i, e[i]);
    }
    const t = this[Symbol.metadata];
    if (t !== null) {
      const e = litPropertyMetadata.get(t);
      if (e !== void 0) for (const [s, i] of e) this.elementProperties.set(s, i);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [e, s] of this.elementProperties) {
      const i = this._$Eu(e, s);
      i !== void 0 && this._$Eh.set(i, e);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(t) {
    const e = [];
    if (Array.isArray(t)) {
      const s = new Set(t.flat(1 / 0).reverse());
      for (const i of s) e.unshift(tt(i));
    } else t !== void 0 && e.push(tt(t));
    return e;
  }
  static _$Eu(t, e) {
    const s = e.attribute;
    return s === !1 ? void 0 : typeof s == "string" ? s : typeof t == "string" ? t.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    var t;
    this._$ES = new Promise((e) => this.enableUpdating = e), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), (t = this.constructor.l) == null || t.forEach((e) => e(this));
  }
  addController(t) {
    var e, s;
    ((e = this._$EO) != null ? e : this._$EO = /* @__PURE__ */ new Set()).add(t), this.renderRoot !== void 0 && this.isConnected && ((s = t.hostConnected) == null || s.call(t));
  }
  removeController(t) {
    var e;
    (e = this._$EO) == null || e.delete(t);
  }
  _$E_() {
    const t = /* @__PURE__ */ new Map(), e = this.constructor.elementProperties;
    for (const s of e.keys()) this.hasOwnProperty(s) && (t.set(s, this[s]), delete this[s]);
    t.size > 0 && (this._$Ep = t);
  }
  createRenderRoot() {
    var e;
    const t = (e = this.shadowRoot) != null ? e : this.attachShadow(this.constructor.shadowRootOptions);
    return Kt(t, this.constructor.elementStyles), t;
  }
  connectedCallback() {
    var t, e;
    (t = this.renderRoot) != null || (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (e = this._$EO) == null || e.forEach((s) => {
      var i;
      return (i = s.hostConnected) == null ? void 0 : i.call(s);
    });
  }
  enableUpdating(t) {
  }
  disconnectedCallback() {
    var t;
    (t = this._$EO) == null || t.forEach((e) => {
      var s;
      return (s = e.hostDisconnected) == null ? void 0 : s.call(e);
    });
  }
  attributeChangedCallback(t, e, s) {
    this._$AK(t, s);
  }
  _$ET(t, e) {
    var n;
    const s = this.constructor.elementProperties.get(t), i = this.constructor._$Eu(t, s);
    if (i !== void 0 && s.reflect === !0) {
      const c = (((n = s.converter) == null ? void 0 : n.toAttribute) !== void 0 ? s.converter : pe).toAttribute(e, s.type);
      this._$Em = t, c == null ? this.removeAttribute(i) : this.setAttribute(i, c), this._$Em = null;
    }
  }
  _$AK(t, e) {
    var n, c, u, d;
    const s = this.constructor, i = s._$Eh.get(t);
    if (i !== void 0 && this._$Em !== i) {
      const f = s.getPropertyOptions(i), p = typeof f.converter == "function" ? { fromAttribute: f.converter } : ((n = f.converter) == null ? void 0 : n.fromAttribute) !== void 0 ? f.converter : pe;
      this._$Em = i, this[i] = (d = (u = p.fromAttribute(e, f.type)) != null ? u : (c = this._$Ej) == null ? void 0 : c.get(i)) != null ? d : null, this._$Em = null;
    }
  }
  requestUpdate(t, e, s) {
    var i, n;
    if (t !== void 0) {
      const c = this.constructor, u = this[t];
      if (s != null || (s = c.getPropertyOptions(t)), !(((i = s.hasChanged) != null ? i : Pe)(u, e) || s.useDefault && s.reflect && u === ((n = this._$Ej) == null ? void 0 : n.get(t)) && !this.hasAttribute(c._$Eu(t, s)))) return;
      this.C(t, e, s);
    }
    this.isUpdatePending === !1 && (this._$ES = this._$EP());
  }
  C(t, e, { useDefault: s, reflect: i, wrapped: n }, c) {
    var u, d, f;
    s && !((u = this._$Ej) != null ? u : this._$Ej = /* @__PURE__ */ new Map()).has(t) && (this._$Ej.set(t, (d = c != null ? c : e) != null ? d : this[t]), n !== !0 || c !== void 0) || (this._$AL.has(t) || (this.hasUpdated || s || (e = void 0), this._$AL.set(t, e)), i === !0 && this._$Em !== t && ((f = this._$Eq) != null ? f : this._$Eq = /* @__PURE__ */ new Set()).add(t));
  }
  async _$EP() {
    this.isUpdatePending = !0;
    try {
      await this._$ES;
    } catch (e) {
      Promise.reject(e);
    }
    const t = this.scheduleUpdate();
    return t != null && await t, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var s, i;
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if ((s = this.renderRoot) != null || (this.renderRoot = this.createRenderRoot()), this._$Ep) {
        for (const [c, u] of this._$Ep) this[c] = u;
        this._$Ep = void 0;
      }
      const n = this.constructor.elementProperties;
      if (n.size > 0) for (const [c, u] of n) {
        const { wrapped: d } = u, f = this[c];
        d !== !0 || this._$AL.has(c) || f === void 0 || this.C(c, void 0, u, f);
      }
    }
    let t = !1;
    const e = this._$AL;
    try {
      t = this.shouldUpdate(e), t ? (this.willUpdate(e), (i = this._$EO) == null || i.forEach((n) => {
        var c;
        return (c = n.hostUpdate) == null ? void 0 : c.call(n);
      }), this.update(e)) : this._$EM();
    } catch (n) {
      throw t = !1, this._$EM(), n;
    }
    t && this._$AE(e);
  }
  willUpdate(t) {
  }
  _$AE(t) {
    var e;
    (e = this._$EO) == null || e.forEach((s) => {
      var i;
      return (i = s.hostUpdated) == null ? void 0 : i.call(s);
    }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
  }
  _$EM() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(t) {
    return !0;
  }
  update(t) {
    this._$Eq && (this._$Eq = this._$Eq.forEach((e) => this._$ET(e, this[e]))), this._$EM();
  }
  updated(t) {
  }
  firstUpdated(t) {
  }
};
var mt;
B.elementStyles = [], B.shadowRootOptions = { mode: "open" }, B[ie("elementProperties")] = /* @__PURE__ */ new Map(), B[ie("finalized")] = /* @__PURE__ */ new Map(), _e == null || _e({ ReactiveElement: B }), ((mt = L.reactiveElementVersions) != null ? mt : L.reactiveElementVersions = []).push("2.1.0");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const oe = globalThis, me = oe.trustedTypes, ot = me ? me.createPolicy("lit-html", { createHTML: (r) => r }) : void 0, $t = "$lit$", N = `lit$${Math.random().toFixed(9).slice(2)}$`, Et = "?" + N, es = `<${Et}>`, j = document, re = () => j.createComment(""), ne = (r) => r === null || typeof r != "object" && typeof r != "function", Ie = Array.isArray, ts = (r) => Ie(r) || typeof (r == null ? void 0 : r[Symbol.iterator]) == "function", Ce = `[ 	
\f\r]`, ee = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, rt = /-->/g, nt = />/g, H = RegExp(`>|${Ce}(?:([^\\s"'>=/]+)(${Ce}*=${Ce}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), at = /'/g, lt = /"/g, wt = /^(?:script|style|textarea|title)$/i, ss = (r) => (t, ...e) => ({ _$litType$: r, strings: t, values: e }), is = ss(1), X = Symbol.for("lit-noChange"), w = Symbol.for("lit-nothing"), ct = /* @__PURE__ */ new WeakMap(), F = j.createTreeWalker(j, 129);
function St(r, t) {
  if (!Ie(r) || !r.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return ot !== void 0 ? ot.createHTML(t) : t;
}
const os = (r, t) => {
  const e = r.length - 1, s = [];
  let i, n = t === 2 ? "<svg>" : t === 3 ? "<math>" : "", c = ee;
  for (let u = 0; u < e; u++) {
    const d = r[u];
    let f, p, b = -1, $ = 0;
    for (; $ < d.length && (c.lastIndex = $, p = c.exec(d), p !== null); ) $ = c.lastIndex, c === ee ? p[1] === "!--" ? c = rt : p[1] !== void 0 ? c = nt : p[2] !== void 0 ? (wt.test(p[2]) && (i = RegExp("</" + p[2], "g")), c = H) : p[3] !== void 0 && (c = H) : c === H ? p[0] === ">" ? (c = i != null ? i : ee, b = -1) : p[1] === void 0 ? b = -2 : (b = c.lastIndex - p[2].length, f = p[1], c = p[3] === void 0 ? H : p[3] === '"' ? lt : at) : c === lt || c === at ? c = H : c === rt || c === nt ? c = ee : (c = H, i = void 0);
    const v = c === H && r[u + 1].startsWith("/>") ? " " : "";
    n += c === ee ? d + es : b >= 0 ? (s.push(f), d.slice(0, b) + $t + d.slice(b) + N + v) : d + N + (b === -2 ? u : v);
  }
  return [St(r, n + (r[e] || "<?>") + (t === 2 ? "</svg>" : t === 3 ? "</math>" : "")), s];
};
class ae {
  constructor({ strings: t, _$litType$: e }, s) {
    let i;
    this.parts = [];
    let n = 0, c = 0;
    const u = t.length - 1, d = this.parts, [f, p] = os(t, e);
    if (this.el = ae.createElement(f, s), F.currentNode = this.el.content, e === 2 || e === 3) {
      const b = this.el.content.firstChild;
      b.replaceWith(...b.childNodes);
    }
    for (; (i = F.nextNode()) !== null && d.length < u; ) {
      if (i.nodeType === 1) {
        if (i.hasAttributes()) for (const b of i.getAttributeNames()) if (b.endsWith($t)) {
          const $ = p[c++], v = i.getAttribute(b).split(N), _ = /([.?@])?(.*)/.exec($);
          d.push({ type: 1, index: n, name: _[2], strings: v, ctor: _[1] === "." ? ns : _[1] === "?" ? as : _[1] === "@" ? ls : be }), i.removeAttribute(b);
        } else b.startsWith(N) && (d.push({ type: 6, index: n }), i.removeAttribute(b));
        if (wt.test(i.tagName)) {
          const b = i.textContent.split(N), $ = b.length - 1;
          if ($ > 0) {
            i.textContent = me ? me.emptyScript : "";
            for (let v = 0; v < $; v++) i.append(b[v], re()), F.nextNode(), d.push({ type: 2, index: ++n });
            i.append(b[$], re());
          }
        }
      } else if (i.nodeType === 8) if (i.data === Et) d.push({ type: 2, index: n });
      else {
        let b = -1;
        for (; (b = i.data.indexOf(N, b + 1)) !== -1; ) d.push({ type: 7, index: n }), b += N.length - 1;
      }
      n++;
    }
  }
  static createElement(t, e) {
    const s = j.createElement("template");
    return s.innerHTML = t, s;
  }
}
function Y(r, t, e = r, s) {
  var c, u, d;
  if (t === X) return t;
  let i = s !== void 0 ? (c = e._$Co) == null ? void 0 : c[s] : e._$Cl;
  const n = ne(t) ? void 0 : t._$litDirective$;
  return (i == null ? void 0 : i.constructor) !== n && ((u = i == null ? void 0 : i._$AO) == null || u.call(i, !1), n === void 0 ? i = void 0 : (i = new n(r), i._$AT(r, e, s)), s !== void 0 ? ((d = e._$Co) != null ? d : e._$Co = [])[s] = i : e._$Cl = i), i !== void 0 && (t = Y(r, i._$AS(r, t.values), i, s)), t;
}
class rs {
  constructor(t, e) {
    this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = e;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(t) {
    var f;
    const { el: { content: e }, parts: s } = this._$AD, i = ((f = t == null ? void 0 : t.creationScope) != null ? f : j).importNode(e, !0);
    F.currentNode = i;
    let n = F.nextNode(), c = 0, u = 0, d = s[0];
    for (; d !== void 0; ) {
      if (c === d.index) {
        let p;
        d.type === 2 ? p = new J(n, n.nextSibling, this, t) : d.type === 1 ? p = new d.ctor(n, d.name, d.strings, this, t) : d.type === 6 && (p = new cs(n, this, t)), this._$AV.push(p), d = s[++u];
      }
      c !== (d == null ? void 0 : d.index) && (n = F.nextNode(), c++);
    }
    return F.currentNode = j, i;
  }
  p(t) {
    let e = 0;
    for (const s of this._$AV) s !== void 0 && (s.strings !== void 0 ? (s._$AI(t, s, e), e += s.strings.length - 2) : s._$AI(t[e])), e++;
  }
}
class J {
  get _$AU() {
    var t, e;
    return (e = (t = this._$AM) == null ? void 0 : t._$AU) != null ? e : this._$Cv;
  }
  constructor(t, e, s, i) {
    var n;
    this.type = 2, this._$AH = w, this._$AN = void 0, this._$AA = t, this._$AB = e, this._$AM = s, this.options = i, this._$Cv = (n = i == null ? void 0 : i.isConnected) != null ? n : !0;
  }
  get parentNode() {
    let t = this._$AA.parentNode;
    const e = this._$AM;
    return e !== void 0 && (t == null ? void 0 : t.nodeType) === 11 && (t = e.parentNode), t;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t, e = this) {
    t = Y(this, t, e), ne(t) ? t === w || t == null || t === "" ? (this._$AH !== w && this._$AR(), this._$AH = w) : t !== this._$AH && t !== X && this._(t) : t._$litType$ !== void 0 ? this.$(t) : t.nodeType !== void 0 ? this.T(t) : ts(t) ? this.k(t) : this._(t);
  }
  O(t) {
    return this._$AA.parentNode.insertBefore(t, this._$AB);
  }
  T(t) {
    this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
  }
  _(t) {
    this._$AH !== w && ne(this._$AH) ? this._$AA.nextSibling.data = t : this.T(j.createTextNode(t)), this._$AH = t;
  }
  $(t) {
    var n;
    const { values: e, _$litType$: s } = t, i = typeof s == "number" ? this._$AC(t) : (s.el === void 0 && (s.el = ae.createElement(St(s.h, s.h[0]), this.options)), s);
    if (((n = this._$AH) == null ? void 0 : n._$AD) === i) this._$AH.p(e);
    else {
      const c = new rs(i, this), u = c.u(this.options);
      c.p(e), this.T(u), this._$AH = c;
    }
  }
  _$AC(t) {
    let e = ct.get(t.strings);
    return e === void 0 && ct.set(t.strings, e = new ae(t)), e;
  }
  k(t) {
    Ie(this._$AH) || (this._$AH = [], this._$AR());
    const e = this._$AH;
    let s, i = 0;
    for (const n of t) i === e.length ? e.push(s = new J(this.O(re()), this.O(re()), this, this.options)) : s = e[i], s._$AI(n), i++;
    i < e.length && (this._$AR(s && s._$AB.nextSibling, i), e.length = i);
  }
  _$AR(t = this._$AA.nextSibling, e) {
    var s;
    for ((s = this._$AP) == null ? void 0 : s.call(this, !1, !0, e); t && t !== this._$AB; ) {
      const i = t.nextSibling;
      t.remove(), t = i;
    }
  }
  setConnected(t) {
    var e;
    this._$AM === void 0 && (this._$Cv = t, (e = this._$AP) == null || e.call(this, t));
  }
}
class be {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(t, e, s, i, n) {
    this.type = 1, this._$AH = w, this._$AN = void 0, this.element = t, this.name = e, this._$AM = i, this.options = n, s.length > 2 || s[0] !== "" || s[1] !== "" ? (this._$AH = Array(s.length - 1).fill(new String()), this.strings = s) : this._$AH = w;
  }
  _$AI(t, e = this, s, i) {
    const n = this.strings;
    let c = !1;
    if (n === void 0) t = Y(this, t, e, 0), c = !ne(t) || t !== this._$AH && t !== X, c && (this._$AH = t);
    else {
      const u = t;
      let d, f;
      for (t = n[0], d = 0; d < n.length - 1; d++) f = Y(this, u[s + d], e, d), f === X && (f = this._$AH[d]), c || (c = !ne(f) || f !== this._$AH[d]), f === w ? t = w : t !== w && (t += (f != null ? f : "") + n[d + 1]), this._$AH[d] = f;
    }
    c && !i && this.j(t);
  }
  j(t) {
    t === w ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t != null ? t : "");
  }
}
class ns extends be {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t) {
    this.element[this.name] = t === w ? void 0 : t;
  }
}
class as extends be {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t) {
    this.element.toggleAttribute(this.name, !!t && t !== w);
  }
}
class ls extends be {
  constructor(t, e, s, i, n) {
    super(t, e, s, i, n), this.type = 5;
  }
  _$AI(t, e = this) {
    var c;
    if ((t = (c = Y(this, t, e, 0)) != null ? c : w) === X) return;
    const s = this._$AH, i = t === w && s !== w || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, n = t !== w && (s === w || i);
    i && this.element.removeEventListener(this.name, this, s), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
  }
  handleEvent(t) {
    var e, s;
    typeof this._$AH == "function" ? this._$AH.call((s = (e = this.options) == null ? void 0 : e.host) != null ? s : this.element, t) : this._$AH.handleEvent(t);
  }
}
class cs {
  constructor(t, e, s) {
    this.element = t, this.type = 6, this._$AN = void 0, this._$AM = e, this.options = s;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t) {
    Y(this, t);
  }
}
const Ts = { I: J }, Me = oe.litHtmlPolyfillSupport;
var bt;
Me == null || Me(ae, J), ((bt = oe.litHtmlVersions) != null ? bt : oe.litHtmlVersions = []).push("3.3.0");
const ds = (r, t, e) => {
  var n, c;
  const s = (n = e == null ? void 0 : e.renderBefore) != null ? n : t;
  let i = s._$litPart$;
  if (i === void 0) {
    const u = (c = e == null ? void 0 : e.renderBefore) != null ? c : null;
    s._$litPart$ = i = new J(t.insertBefore(re(), u), u, void 0, e != null ? e : {});
  }
  return i._$AI(r), i;
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const W = globalThis;
class K extends B {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    var e, s;
    const t = super.createRenderRoot();
    return (s = (e = this.renderOptions).renderBefore) != null || (e.renderBefore = t.firstChild), t;
  }
  update(t) {
    const e = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = ds(e, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var t;
    super.connectedCallback(), (t = this._$Do) == null || t.setConnected(!0);
  }
  disconnectedCallback() {
    var t;
    super.disconnectedCallback(), (t = this._$Do) == null || t.setConnected(!1);
  }
  render() {
    return X;
  }
}
var yt;
K._$litElement$ = !0, K.finalized = !0, (yt = W.litElementHydrateSupport) == null || yt.call(W, { LitElement: K });
const xe = W.litElementPolyfillSupport;
xe == null || xe({ LitElement: K });
var gt;
((gt = W.litElementVersions) != null ? gt : W.litElementVersions = []).push("4.2.0");
(function() {
  (function(r) {
    const t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap(), u = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap(), p = /* @__PURE__ */ new WeakMap(), b = /* @__PURE__ */ new WeakMap(), $ = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap(), _ = /* @__PURE__ */ new WeakMap(), C = /* @__PURE__ */ new WeakMap(), z = {
      ariaAtomic: "aria-atomic",
      ariaAutoComplete: "aria-autocomplete",
      ariaBusy: "aria-busy",
      ariaChecked: "aria-checked",
      ariaColCount: "aria-colcount",
      ariaColIndex: "aria-colindex",
      ariaColIndexText: "aria-colindextext",
      ariaColSpan: "aria-colspan",
      ariaCurrent: "aria-current",
      ariaDescription: "aria-description",
      ariaDisabled: "aria-disabled",
      ariaExpanded: "aria-expanded",
      ariaHasPopup: "aria-haspopup",
      ariaHidden: "aria-hidden",
      ariaInvalid: "aria-invalid",
      ariaKeyShortcuts: "aria-keyshortcuts",
      ariaLabel: "aria-label",
      ariaLevel: "aria-level",
      ariaLive: "aria-live",
      ariaModal: "aria-modal",
      ariaMultiLine: "aria-multiline",
      ariaMultiSelectable: "aria-multiselectable",
      ariaOrientation: "aria-orientation",
      ariaPlaceholder: "aria-placeholder",
      ariaPosInSet: "aria-posinset",
      ariaPressed: "aria-pressed",
      ariaReadOnly: "aria-readonly",
      ariaRelevant: "aria-relevant",
      ariaRequired: "aria-required",
      ariaRoleDescription: "aria-roledescription",
      ariaRowCount: "aria-rowcount",
      ariaRowIndex: "aria-rowindex",
      ariaRowIndexText: "aria-rowindextext",
      ariaRowSpan: "aria-rowspan",
      ariaSelected: "aria-selected",
      ariaSetSize: "aria-setsize",
      ariaSort: "aria-sort",
      ariaValueMax: "aria-valuemax",
      ariaValueMin: "aria-valuemin",
      ariaValueNow: "aria-valuenow",
      ariaValueText: "aria-valuetext",
      role: "role"
    }, Dt = (a, o) => {
      for (let l in z) {
        o[l] = null;
        let h = null;
        const m = z[l];
        Object.defineProperty(o, l, {
          get() {
            return h;
          },
          set(y) {
            h = y, a.isConnected ? O(a, m, y) : p.set(a, o);
          }
        });
      }
    };
    function Ne(a) {
      const o = i.get(a), { form: l } = o;
      Fe(a, l, o), Ve(a, o.labels);
    }
    const Le = (a, o = !1) => {
      const l = document.createTreeWalker(a, NodeFilter.SHOW_ELEMENT, {
        acceptNode(y) {
          return i.has(y) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
      });
      let h = l.nextNode();
      const m = !o || a.disabled;
      for (; h; )
        h.formDisabledCallback && m && ve(h, a.disabled), h = l.nextNode();
    }, Re = { attributes: !0, attributeFilter: ["disabled", "name"] }, le = he() ? new MutationObserver((a) => {
      for (const o of a) {
        const l = o.target;
        if (o.attributeName === "disabled" && (l.constructor.formAssociated ? ve(l, l.hasAttribute("disabled")) : l.localName === "fieldset" && Le(l)), o.attributeName === "name" && l.constructor.formAssociated) {
          const h = i.get(l), m = f.get(l);
          h.setFormValue(m);
        }
      }
    }) : {};
    function ye(a) {
      a.forEach((o) => {
        const { addedNodes: l, removedNodes: h } = o, m = Array.from(l), y = Array.from(h);
        m.forEach((g) => {
          var A;
          if (i.has(g) && g.constructor.formAssociated && Ne(g), p.has(g)) {
            const E = p.get(g);
            Object.keys(z).filter((M) => E[M] !== null).forEach((M) => {
              O(g, z[M], E[M]);
            }), p.delete(g);
          }
          if (C.has(g)) {
            const E = C.get(g);
            O(g, "internals-valid", E.validity.valid.toString()), O(g, "internals-invalid", (!E.validity.valid).toString()), O(g, "aria-invalid", (!E.validity.valid).toString()), C.delete(g);
          }
          if (g.localName === "form") {
            const E = d.get(g), D = document.createTreeWalker(g, NodeFilter.SHOW_ELEMENT, {
              acceptNode(Se) {
                return i.has(Se) && Se.constructor.formAssociated && !(E && E.has(Se)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
              }
            });
            let M = D.nextNode();
            for (; M; )
              Ne(M), M = D.nextNode();
          }
          g.localName === "fieldset" && ((A = le.observe) === null || A === void 0 || A.call(le, g, Re), Le(g, !0));
        }), y.forEach((g) => {
          const A = i.get(g);
          A && s.get(A) && Ue(A), u.has(g) && u.get(g).disconnect();
        });
      });
    }
    function Tt(a) {
      a.forEach((o) => {
        const { removedNodes: l } = o;
        l.forEach((h) => {
          const m = v.get(o.target);
          i.has(h) && je(h), m.disconnect();
        });
      });
    }
    const kt = (a) => {
      var o, l;
      const h = new MutationObserver(Tt);
      !((o = window == null ? void 0 : window.ShadyDOM) === null || o === void 0) && o.inUse && a.mode && a.host && (a = a.host), (l = h.observe) === null || l === void 0 || l.call(h, a, { childList: !0 }), v.set(a, h);
    };
    he() && new MutationObserver(ye);
    const ge = {
      childList: !0,
      subtree: !0
    }, O = (a, o, l) => {
      a.getAttribute(o) !== l && a.setAttribute(o, l);
    }, ve = (a, o) => {
      a.toggleAttribute("internals-disabled", o), o ? O(a, "aria-disabled", "true") : a.removeAttribute("aria-disabled"), a.formDisabledCallback && a.formDisabledCallback.apply(a, [o]);
    }, Ue = (a) => {
      s.get(a).forEach((l) => {
        l.remove();
      }), s.set(a, []);
    }, He = (a, o) => {
      const l = document.createElement("input");
      return l.type = "hidden", l.name = a.getAttribute("name"), a.after(l), s.get(o).push(l), l;
    }, Ot = (a, o) => {
      var l;
      s.set(o, []), (l = le.observe) === null || l === void 0 || l.call(le, a, Re);
    }, Ve = (a, o) => {
      if (o.length) {
        Array.from(o).forEach((h) => h.addEventListener("click", a.click.bind(a)));
        let l = o[0].id;
        o[0].id || (l = `${o[0].htmlFor}_Label`, o[0].id = l), O(a, "aria-labelledby", l);
      }
    }, ce = (a) => {
      const o = Array.from(a.elements).filter((y) => !y.tagName.includes("-") && y.validity).map((y) => y.validity.valid), l = d.get(a) || [], h = Array.from(l).filter((y) => y.isConnected).map((y) => i.get(y).validity.valid), m = [...o, ...h].includes(!1);
      a.toggleAttribute("internals-invalid", m), a.toggleAttribute("internals-valid", !m);
    }, Pt = (a) => {
      ce(de(a.target));
    }, It = (a) => {
      ce(de(a.target));
    }, Nt = (a) => {
      const o = ["button[type=submit]", "input[type=submit]", "button:not([type])"].map((l) => `${l}:not([disabled])`).map((l) => `${l}:not([form])${a.id ? `,${l}[form='${a.id}']` : ""}`).join(",");
      a.addEventListener("click", (l) => {
        if (l.target.closest(o)) {
          const m = d.get(a);
          if (a.noValidate)
            return;
          m.size && Array.from(m).reverse().map((A) => i.get(A).reportValidity()).includes(!1) && l.preventDefault();
        }
      });
    }, Lt = (a) => {
      const o = d.get(a.target);
      o && o.size && o.forEach((l) => {
        l.constructor.formAssociated && l.formResetCallback && l.formResetCallback.apply(l);
      });
    }, Fe = (a, o, l) => {
      if (o) {
        const h = d.get(o);
        if (h)
          h.add(a);
        else {
          const m = /* @__PURE__ */ new Set();
          m.add(a), d.set(o, m), Nt(o), o.addEventListener("reset", Lt), o.addEventListener("input", Pt), o.addEventListener("change", It);
        }
        c.set(o, { ref: a, internals: l }), a.constructor.formAssociated && a.formAssociatedCallback && setTimeout(() => {
          a.formAssociatedCallback.apply(a, [o]);
        }, 0), ce(o);
      }
    }, de = (a) => {
      let o = a.parentNode;
      return o && o.tagName !== "FORM" && (o = de(o)), o;
    }, x = (a, o, l = DOMException) => {
      if (!a.constructor.formAssociated)
        throw new l(o);
    }, We = (a, o, l) => {
      const h = d.get(a);
      return h && h.size && h.forEach((m) => {
        i.get(m)[l]() || (o = !1);
      }), o;
    }, je = (a) => {
      if (a.constructor.formAssociated) {
        const o = i.get(a), { labels: l, form: h } = o;
        Ve(a, l), Fe(a, h, o);
      }
    };
    function he() {
      return typeof MutationObserver < "u";
    }
    class Rt {
      constructor() {
        this.badInput = !1, this.customError = !1, this.patternMismatch = !1, this.rangeOverflow = !1, this.rangeUnderflow = !1, this.stepMismatch = !1, this.tooLong = !1, this.tooShort = !1, this.typeMismatch = !1, this.valid = !0, this.valueMissing = !1, Object.seal(this);
      }
    }
    const Ut = (a) => (a.badInput = !1, a.customError = !1, a.patternMismatch = !1, a.rangeOverflow = !1, a.rangeUnderflow = !1, a.stepMismatch = !1, a.tooLong = !1, a.tooShort = !1, a.typeMismatch = !1, a.valid = !0, a.valueMissing = !1, a), Ht = (a, o, l) => (a.valid = Vt(o), Object.keys(o).forEach((h) => a[h] = o[h]), l && ce(l), a), Vt = (a) => {
      let o = !0;
      for (let l in a)
        l !== "valid" && a[l] !== !1 && (o = !1);
      return o;
    }, $e = /* @__PURE__ */ new WeakMap();
    function ze(a, o) {
      a.toggleAttribute(o, !0), a.part && a.part.add(o);
    }
    class Ee extends Set {
      static get isPolyfilled() {
        return !0;
      }
      constructor(o) {
        if (super(), !o || !o.tagName || o.tagName.indexOf("-") === -1)
          throw new TypeError("Illegal constructor");
        $e.set(this, o);
      }
      add(o) {
        if (!/^--/.test(o) || typeof o != "string")
          throw new DOMException(`Failed to execute 'add' on 'CustomStateSet': The specified value ${o} must start with '--'.`);
        const l = super.add(o), h = $e.get(this), m = `state${o}`;
        return h.isConnected ? ze(h, m) : setTimeout(() => {
          ze(h, m);
        }), l;
      }
      clear() {
        for (let [o] of this.entries())
          this.delete(o);
        super.clear();
      }
      delete(o) {
        const l = super.delete(o), h = $e.get(this);
        return h.isConnected ? (h.toggleAttribute(`state${o}`, !1), h.part && h.part.remove(`state${o}`)) : setTimeout(() => {
          h.toggleAttribute(`state${o}`, !1), h.part && h.part.remove(`state${o}`);
        }), l;
      }
    }
    function Be(a, o, l, h) {
      if (typeof o == "function" ? a !== o || !0 : !o.has(a)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
      return l === "m" ? h : l === "a" ? h.call(a) : h ? h.value : o.get(a);
    }
    function Ft(a, o, l, h, m) {
      if (typeof o == "function" ? a !== o || !0 : !o.has(a)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
      return o.set(a, l), l;
    }
    var Q;
    class Wt {
      constructor(o) {
        Q.set(this, void 0), Ft(this, Q, o);
        for (let l = 0; l < o.length; l++) {
          let h = o[l];
          this[l] = h, h.hasAttribute("name") && (this[h.getAttribute("name")] = h);
        }
        Object.freeze(this);
      }
      get length() {
        return Be(this, Q, "f").length;
      }
      [(Q = /* @__PURE__ */ new WeakMap(), Symbol.iterator)]() {
        return Be(this, Q, "f")[Symbol.iterator]();
      }
      item(o) {
        return this[o] == null ? null : this[o];
      }
      namedItem(o) {
        return this[o] == null ? null : this[o];
      }
    }
    function jt() {
      const a = HTMLFormElement.prototype.checkValidity;
      HTMLFormElement.prototype.checkValidity = l;
      const o = HTMLFormElement.prototype.reportValidity;
      HTMLFormElement.prototype.reportValidity = h;
      function l(...y) {
        let g = a.apply(this, y);
        return We(this, g, "checkValidity");
      }
      function h(...y) {
        let g = o.apply(this, y);
        return We(this, g, "reportValidity");
      }
      const { get: m } = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, "elements");
      Object.defineProperty(HTMLFormElement.prototype, "elements", {
        get(...y) {
          const g = m.call(this, ...y), A = Array.from(d.get(this) || []);
          if (A.length === 0)
            return g;
          const E = Array.from(g).concat(A).sort((D, M) => D.compareDocumentPosition ? D.compareDocumentPosition(M) & 2 ? 1 : -1 : 0);
          return new Wt(E);
        }
      });
    }
    class Ke {
      static get isPolyfilled() {
        return !0;
      }
      constructor(o) {
        if (!o || !o.tagName || o.tagName.indexOf("-") === -1)
          throw new TypeError("Illegal constructor");
        const l = o.getRootNode(), h = new Rt();
        this.states = new Ee(o), t.set(this, o), e.set(this, h), i.set(o, this), Dt(o, this), Ot(o, this), Object.seal(this), l instanceof DocumentFragment && kt(l);
      }
      checkValidity() {
        const o = t.get(this);
        if (x(o, "Failed to execute 'checkValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate)
          return !0;
        const l = e.get(this);
        if (!l.valid) {
          const h = new Event("invalid", {
            bubbles: !1,
            cancelable: !0,
            composed: !1
          });
          o.dispatchEvent(h);
        }
        return l.valid;
      }
      get form() {
        const o = t.get(this);
        x(o, "Failed to read the 'form' property from 'ElementInternals': The target element is not a form-associated custom element.");
        let l;
        return o.constructor.formAssociated === !0 && (l = de(o)), l;
      }
      get labels() {
        const o = t.get(this);
        x(o, "Failed to read the 'labels' property from 'ElementInternals': The target element is not a form-associated custom element.");
        const l = o.getAttribute("id"), h = o.getRootNode();
        return h && l ? h.querySelectorAll(`[for="${l}"]`) : [];
      }
      reportValidity() {
        const o = t.get(this);
        if (x(o, "Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate)
          return !0;
        const l = this.checkValidity(), h = $.get(this);
        if (h && !o.constructor.formAssociated)
          throw new DOMException("Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element.");
        return !l && h && (o.focus(), h.focus()), l;
      }
      setFormValue(o) {
        const l = t.get(this);
        if (x(l, "Failed to execute 'setFormValue' on 'ElementInternals': The target element is not a form-associated custom element."), Ue(this), o != null && !(o instanceof FormData)) {
          if (l.getAttribute("name")) {
            const h = He(l, this);
            h.value = o;
          }
        } else o != null && o instanceof FormData && Array.from(o).reverse().forEach(([h, m]) => {
          if (typeof m == "string") {
            const y = He(l, this);
            y.name = h, y.value = m;
          }
        });
        f.set(l, o);
      }
      setValidity(o, l, h) {
        const m = t.get(this);
        if (x(m, "Failed to execute 'setValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !o)
          throw new TypeError("Failed to execute 'setValidity' on 'ElementInternals': 1 argument required, but only 0 present.");
        $.set(this, h);
        const y = e.get(this), g = {};
        for (const D in o)
          g[D] = o[D];
        Object.keys(g).length === 0 && Ut(y);
        const A = Object.assign(Object.assign({}, y), g);
        delete A.valid;
        const { valid: E } = Ht(y, A, this.form);
        if (!E && !l)
          throw new DOMException("Failed to execute 'setValidity' on 'ElementInternals': The second argument should not be empty if one or more flags in the first argument are true.");
        n.set(this, E ? "" : l), m.isConnected ? (m.toggleAttribute("internals-invalid", !E), m.toggleAttribute("internals-valid", E), O(m, "aria-invalid", `${!E}`)) : C.set(m, this);
      }
      get shadowRoot() {
        const o = t.get(this), l = b.get(o);
        return l || null;
      }
      get validationMessage() {
        const o = t.get(this);
        return x(o, "Failed to read the 'validationMessage' property from 'ElementInternals': The target element is not a form-associated custom element."), n.get(this);
      }
      get validity() {
        const o = t.get(this);
        return x(o, "Failed to read the 'validity' property from 'ElementInternals': The target element is not a form-associated custom element."), e.get(this);
      }
      get willValidate() {
        const o = t.get(this);
        return x(o, "Failed to read the 'willValidate' property from 'ElementInternals': The target element is not a form-associated custom element."), !(o.disabled || o.hasAttribute("disabled") || o.hasAttribute("readonly"));
      }
    }
    function zt() {
      if (typeof window > "u" || !window.ElementInternals || !HTMLElement.prototype.attachInternals)
        return !1;
      class a extends HTMLElement {
        constructor() {
          super(), this.internals = this.attachInternals();
        }
      }
      const o = `element-internals-feature-detection-${Math.random().toString(36).replace(/[^a-z]+/g, "")}`;
      customElements.define(o, a);
      const l = new a();
      return [
        "shadowRoot",
        "form",
        "willValidate",
        "validity",
        "validationMessage",
        "labels",
        "setFormValue",
        "setValidity",
        "checkValidity",
        "reportValidity"
      ].every((h) => h in l.internals);
    }
    let qe = !1, Ge = !1;
    function we(a) {
      Ge || (Ge = !0, window.CustomStateSet = Ee, a && (HTMLElement.prototype.attachInternals = function(...o) {
        const l = a.call(this, o);
        return l.states = new Ee(this), l;
      }));
    }
    function Xe(a = !0) {
      if (!qe) {
        if (qe = !0, typeof window < "u" && (window.ElementInternals = Ke), typeof CustomElementRegistry < "u") {
          const o = CustomElementRegistry.prototype.define;
          CustomElementRegistry.prototype.define = function(l, h, m) {
            if (h.formAssociated) {
              const y = h.prototype.connectedCallback;
              h.prototype.connectedCallback = function() {
                _.has(this) || (_.set(this, !0), this.hasAttribute("disabled") && ve(this, !0)), y != null && y.apply(this), je(this);
              };
            }
            o.call(this, l, h, m);
          };
        }
        if (typeof HTMLElement < "u" && (HTMLElement.prototype.attachInternals = function() {
          if (this.tagName) {
            if (this.tagName.indexOf("-") === -1)
              throw new Error("Failed to execute 'attachInternals' on 'HTMLElement': Unable to attach ElementInternals to non-custom elements.");
          } else return {};
          if (i.has(this))
            throw new DOMException("DOMException: Failed to execute 'attachInternals' on 'HTMLElement': ElementInternals for the specified element was already attached.");
          return new Ke(this);
        }), typeof Element < "u") {
          let o = function(...h) {
            const m = l.apply(this, h);
            if (b.set(this, m), he()) {
              const y = new MutationObserver(ye);
              window.ShadyDOM ? y.observe(this, ge) : y.observe(m, ge), u.set(this, y);
            }
            return m;
          };
          const l = Element.prototype.attachShadow;
          Element.prototype.attachShadow = o;
        }
        he() && typeof document < "u" && new MutationObserver(ye).observe(document.documentElement, ge), typeof HTMLFormElement < "u" && jt(), (a || typeof window < "u" && !window.CustomStateSet) && we();
      }
    }
    return !!customElements.polyfillWrapFlushCallback || (zt() ? typeof window < "u" && !window.CustomStateSet && we(HTMLElement.prototype.attachInternals) : Xe(!1)), r.forceCustomStateSetPolyfill = we, r.forceElementInternalsPolyfill = Xe, Object.defineProperty(r, "__esModule", { value: !0 }), r;
  })({});
})();
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const hs = { attribute: !0, type: String, converter: pe, reflect: !1, hasChanged: Pe }, us = (r = hs, t, e) => {
  const { kind: s, metadata: i } = e;
  let n = globalThis.litPropertyMetadata.get(i);
  if (n === void 0 && globalThis.litPropertyMetadata.set(i, n = /* @__PURE__ */ new Map()), s === "setter" && ((r = Object.create(r)).wrapped = !0), n.set(e.name, r), s === "accessor") {
    const { name: c } = e;
    return { set(u) {
      const d = t.get.call(this);
      t.set.call(this, u), this.requestUpdate(c, d, r);
    }, init(u) {
      return u !== void 0 && this.C(c, void 0, r, u), u;
    } };
  }
  if (s === "setter") {
    const { name: c } = e;
    return function(u) {
      const d = this[c];
      t.call(this, u), this.requestUpdate(c, d, r);
    };
  }
  throw Error("Unsupported decorator location: " + s);
};
function R(r) {
  return (t, e) => typeof e == "object" ? us(r, t, e) : ((s, i, n) => {
    const c = i.hasOwnProperty(n);
    return i.constructor.createProperty(n, s), c ? Object.getOwnPropertyDescriptor(i, n) : void 0;
  })(r, t, e);
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function At(r) {
  return R({ ...r, state: !0, attribute: !1 });
}
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const _t = Symbol.for(""), fs = (r) => {
  if ((r == null ? void 0 : r.r) === _t) return r == null ? void 0 : r._$litStatic$;
}, ps = (r) => ({ _$litStatic$: r, r: _t }), dt = /* @__PURE__ */ new Map(), ms = (r) => (t, ...e) => {
  const s = e.length;
  let i, n;
  const c = [], u = [];
  let d, f = 0, p = !1;
  for (; f < s; ) {
    for (d = t[f]; f < s && (n = e[f], (i = fs(n)) !== void 0); ) d += i + t[++f], p = !0;
    f !== s && u.push(n), c.push(d), f++;
  }
  if (f === s && c.push(t[s]), p) {
    const b = c.join("$$lit$$");
    (t = dt.get(b)) === void 0 && (c.raw = c, dt.set(b, t = c)), e = u;
  }
  return r(t, ...e);
}, ks = ms(is);
var fe = /* @__PURE__ */ ((r) => (r.NO_SYNC = "no-sync", r))(fe || {}), q = /* @__PURE__ */ ((r) => (r.VISIBLE = "visible", r.IDLE = "idle", r.INTERACTION = "interaction", r.MEDIA = "media", r.DEFINED = "defined", r))(q || {});
const bs = Z`[beacon-tag-name]:not([focus-override]) *:focus-visible:not(.beacon-control__field,.skip-focus-override,a:not([focus-override])){box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}[beacon-tag-name]:not([focus-override]) *:focus-visible:not(.beacon-control__field,.skip-focus-override,a:not([focus-override])):not(dialog){position:relative}[beacon-tag-name]:not([focus-override]) a:not([focus-override]):focus-visible{background-color:var(--beacon-system-color-background-link-focus)!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo) 0 0 var(--beacon-system-color-border-link-focus);color:var(--beacon-system-color-text-set-navy)!important;outline:none;text-decoration:none}@media (forced-colors: active){[beacon-tag-name]:not([focus-override]) a:not([focus-override]):focus-visible{border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus)}}`, Ct = Z`:host(:not([focus-override],.skip-focus-override)) *:not(.skip-focus-override,a:not([focus-override])):focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}:host(:not([focus-override],.skip-focus-override)) *:not(.skip-focus-override,a:not([focus-override])):focus-visible:not(dialog){position:relative}:host(:not([focus-override],.skip-focus-override)) a:not([focus-override]):focus-visible{background-color:var(--beacon-system-color-background-link-focus)!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo) 0 0 var(--beacon-system-color-border-link-focus);color:var(--beacon-system-color-text-set-navy)!important;outline:none;text-decoration:none}@media (forced-colors: active){:host(:not([focus-override],.skip-focus-override)) a:not([focus-override]):focus-visible{border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus)}}`, ys = Z`:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-small);--motion-translate-intro-micro: 3rem}@media (width >= 640px){:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-medium);--motion-translate-intro-micro: 4rem}}@media (width >= 960px){:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-large);--motion-translate-intro-micro: 5rem}}@media (width >= 1280px){:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-x-large);--motion-translate-intro-micro: 6rem}}@media (width >= 1600px){:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-xx-large);--motion-translate-intro-micro: 8rem}}@media (width >= 1920px){:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-xxx-large);--motion-translate-intro-micro: 9rem}}`, gs = Z`[beacon-tag-name]:where([reset-spacing]) *{margin:0;padding:0}`, Mt = Z`:host{border:initial;box-sizing:border-box;display:block;font-size:initial;font-style:initial;font-variant:initial;font-weight:initial;line-height:initial;white-space:initial;word-break:break-word;word-spacing:initial;text-align:initial;text-indent:initial;text-transform:initial}:host *,:host *:before,:host *:after{box-sizing:inherit}input,button,textarea,select{font:inherit;letter-spacing:inherit}button{color:inherit;cursor:pointer}ul,ol{list-style-position:initial;list-style-type:revert}::slotted(:is(ul,ol)[role=list]){list-style:none;padding:0}table{caption-side:initial;empty-cells:initial;border-collapse:initial;border-spacing:initial}`, xt = Z`.has-cell-padding,.has-component-padding{padding-block:var(--beacon-reference-space-3);padding-inline:var(--beacon-reference-space-3)}:host{color:var(--beacon-system-color-text-standard);font-family:var(--beacon-system-font-family-body);-webkit-font-smoothing:antialiased;font-weight:var(--beacon-system-font-weight-light)}a,::slotted(a){color:var(--beacon-system-color-text-link)}a:not([class],:is(:hover,:focus)){text-decoration:none}:host(:not([motion-state=enabled])),:host(:not([motion-state=enabled])) :is(*,*:before,*:after),:host(:not([motion-state=enabled])) ::slotted(*:not([motion-state=enabled])){animation:none;animation-duration:.01ms!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition:none!important}@media (prefers-reduced-motion: reduce){:host([motion-state=enabled]),:host([motion-state=enabled]) :is(*,*:before,*:after),:host([motion-state]),:host([motion-state]) :is(*,*:before,*:after){animation:none;animation-duration:.01ms!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition:none!important}}`;
var se = /* @__PURE__ */ ((r) => (r.CLICKABLE = "data-metrics-clickable", r.TYPE = "data-metrics-type", r.TEXT = "data-metrics-link-text", r.LOCATION = "data-metrics-location", r))(se || {});
const I = class I {
};
I.setPropertyOnEvent = (t, e, s, i) => {
  try {
    Object.defineProperty(t, s, {
      value: i || e[`${s}`],
      writable: !1
    });
  } catch (n) {
    console.warn(n);
  }
}, I.getAnalyticsEvents = () => {
  const t = ["gesture", "click", "touch", "change"];
  return Object.keys(window).filter((e) => /^on/.test(e) && new RegExp(t.join("|")).test(e) && e !== "onscrollsnapchange");
}, I.setHostEventHandlerForAnalytics = (t, e) => {
  var n;
  const s = I.getAnalyticsEvents(), i = "beaconVersion";
  for (const c of s) {
    const u = c.slice(2);
    (n = t.shadowRoot) == null || n.addEventListener(
      u,
      (d) => {
        var p;
        const f = new d.constructor(
          u,
          d
        );
        I.setPropertyOnEvent(
          f,
          null,
          i,
          e
        );
        for (const b in d)
          b !== "isTrusted" && I.setPropertyOnEvent(f, d, b);
        (p = t.shadowRoot) != null && p.contains(d.target) && t.dispatchEvent(f);
      },
      !0
    );
  }
};
let ke = I;
function Os(r, t) {
  !r || !t || r instanceof SVGElement && (r.setAttribute(se.CLICKABLE, "true"), r.setAttribute(se.TYPE, "BTN"), r.getAttribute(se.TEXT) || r.setAttribute(se.TEXT, t));
}
function Ps(r) {
  return !!r.updateAnalytics;
}
function te(r, t, e, s) {
  const i = new CustomEvent(t, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...e
  });
  return r.dispatchEvent(i), s && s(), i;
}
const ht = (r) => !!r.deferrable, vs = (r) => {
  var t, e;
  return (!!((t = r.deferList) != null && t.includes(q.VISIBLE)) || !!((e = r.getAttribute("defer-until")) != null && e.includes(q.VISIBLE))) && r.isDeferUntilParent;
}, ut = (r) => !!navigator.vendor && navigator.vendor.indexOf(r) > -1;
function $s(r) {
  return `${r}`.toLowerCase().replace(new RegExp(/[-_]+/, "g"), " ").replace(new RegExp(/[^\w\s]/, "g"), "").replace(
    new RegExp(/\s+(.)(\w*)/, "g"),
    (t, e, s) => `${e.toUpperCase() + s}`
  ).replace(new RegExp(/\w/), (t) => t.toUpperCase());
}
const Es = "4.4.0", ws = {
  rootMargin: "1500px",
  threshold: 0
}, T = {
  version: Es,
  hidden: "hidden",
  safari: "Apple",
  deprecatedPropertyKeys: ["alternateAttributes", "sync", "alternateSlot"],
  defaultDeferOptions: ws
}, De = (r) => {
  for (const t of r)
    if (t !== void 0) return t;
};
class Te extends CSSStyleSheet {
  constructor(t, e) {
    super(), this.name = t, this.replaceSync(e);
  }
}
var Ss = Object.defineProperty, U = (r, t, e, s) => {
  for (var i = void 0, n = r.length - 1, c; n >= 0; n--)
    (c = r[n]) && (i = c(t, e, i) || i);
  return i && Ss(t, e, i), i;
};
const As = [Mt, xt, Ct];
var G, S;
const k = (S = class extends K {
  constructor() {
    super();
    Qe(this, G);
    Ae(this, G, !1), this.isDeferUntilParent = !1, this.deferrable = !1, this.focusOverride = !1, this.resetSpacing = !1, this.beaconTagName = "", this.version = T.version, this.motionState = "disabled", this.prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches, this.alternateSlots = /* @__PURE__ */ new Map(), this.onslotchange = (e) => {
      const { target: s } = e, i = s.name;
      this.slotDeprecationWarn(i);
    }, this.resolvedDeferOptions = {
      root: document,
      rootMargin: T.defaultDeferOptions.rootMargin,
      threshold: T.defaultDeferOptions.threshold
    }, this.deferUntilVisible = () => new Promise((e) => {
      if (!("IntersectionObserver" in window))
        e();
      else {
        const s = new IntersectionObserver((i) => {
          const [n] = i;
          n.isIntersecting && (s.disconnect(), e());
        }, this.getResolvedDeferOptions() || null);
        s.observe(this);
      }
    }), this.deferUntilIdle = () => {
      const e = new Promise((s) => {
        document.readyState !== "complete" ? window.addEventListener("load", () => s(), { once: !0 }) : s();
      });
      return "requestIdleCallback" in window ? Promise.all([
        new Promise((s) => {
          requestIdleCallback(() => {
            s();
          });
        }),
        e
      ]) : e;
    }, this.deferredChildEventHandler = (e) => new Promise((s) => {
      var i;
      e instanceof CustomEvent && ((i = e.detail) != null && i.type) ? (this.deferOptions && this.setDeferOptions(this.deferOptions), this.selectDeferUntilHandler(e.detail.type).then(() => s())) : s();
    }), this.renderStyles = (e, s) => {
      const i = [], n = new Set(
        this.constructor[e].flat(1 / 0)
      );
      for (const c of n)
        i.push(c);
      V ? i.forEach((c, u) => {
        var b, $, v;
        const d = this.getClosestHost(), f = `${s}-${u}`, p = new Te(f, c.toString());
        if (d) {
          if (!((b = d.shadowRoot) == null ? void 0 : b.adoptedStyleSheets.find(
            (C) => C.name === f
          )))
            if (p.name.includes("global-light")) {
              const C = parseInt(p.name.slice(-1), 10);
              ($ = d.shadowRoot) == null || $.adoptedStyleSheets.splice(
                As.length + C,
                0,
                p
              );
            } else
              (v = d.shadowRoot) == null || v.adoptedStyleSheets.push(p);
        } else if (!document.adoptedStyleSheets.find(
          (_) => _.name === f
        ))
          if (p.name.includes("global-light")) {
            const _ = parseInt(p.name.slice(-1), 10) + 1, C = document.adoptedStyleSheets.findLastIndex(
              (z) => z.name.includes("global-root")
            );
            document.adoptedStyleSheets.splice(C + _, 0, p);
          } else
            document.adoptedStyleSheets.push(p);
      }) : i.toReversed().forEach((c, u) => {
        var p;
        const d = document.createElement("style");
        d.setAttribute("slot", "lightDOM");
        let f = !1;
        if (d.textContent = c.toString(), s) {
          const b = Math.abs(u - i.length), $ = `${s}-${b}`, v = this.getClosestHost();
          d.id = $, (v && ((p = v == null ? void 0 : v.shadowRoot) != null && p.querySelector(`#${$}`)) || !v && document.querySelector(`#${$}`)) && (f = !0);
        }
        f || this.prepend(d);
      });
    }, this.renderComponentModeStyles = (e = `${this.beaconTagName}-mode-styles`) => {
      var s, i;
      V ? (s = this.componentModeStyles) == null || s.forEach(
        (n, c) => {
          if (!document.adoptedStyleSheets.find(
            (u) => u.name === `${e}-${c}`
          )) {
            const u = new Te(
              `${e}-${c}`,
              n.toString()
            );
            document.adoptedStyleSheets.push(u);
          }
        }
      ) : (i = this.componentModeStyles) == null || i.forEach((n, c) => {
        const u = document.createElement("style");
        u.textContent = n.toString();
        const d = `${e}-${c}`;
        u.id = d, !document.querySelector(`#${d}`) && document.head.append(u);
      });
    }, this.getScopedTag = (e) => {
      if (!e) return null;
      const s = this.getScopedTagPrefix() ? `${this.getScopedTagPrefix()}-${e}` : e;
      return ps(s);
    }, this._internals = this.attachInternals ? this.attachInternals() : void 0;
  }
  /**
   * Extends Lit's definition of `observedAttributes`.
   *
   * Returns a list of attributes corresponding to the registered properties.
   * @nocollapse
   * @category attributes
   */
  static get observedAttributes() {
    const e = [];
    return this.hasDeprecatedProperties && this.alternateAttributesMap.forEach((s, i) => {
      this.elementProperties.has(s) && e.push(i);
    }), e.push(...super.observedAttributes), e;
  }
  /**
   * Extends Lit's default attributeChangedCallback to support deprecated properties.
   *
   * @param name Attribute name
   * @param _old Old value
   * @param value New value
   */
  attributeChangedCallback(e, s, i) {
    const {
      alternateAttributesMap: n,
      hasDeprecatedProperties: c,
      elementProperties: u
    } = this.constructor;
    if (c && n.size > 0) {
      const d = n.get(e), f = this.getPropertyOptions(e).alternateSlot;
      if (d) {
        const p = u.get(d);
        if (d !== fe.NO_SYNC && (i === null ? this.removeAttribute(
          (p == null ? void 0 : p.attribute) || d
        ) : this.setAttribute(
          (p == null ? void 0 : p.attribute) || d,
          i || ""
        )), f) {
          const b = this.createPropertyDeprecationForSlotMessage(e, f);
          console.warn(b);
        } else
          console.warn(
            this.createPropertyDeprecationMessage(
              e,
              d,
              p == null ? void 0 : p.attribute
            )
          );
      }
    }
    super.attributeChangedCallback(e, s, i);
  }
  /**
   * Generates a console message to log when deprecated properties were used.
   *
   * @param name attribute that triggered the message
   * @param prop property that the attribute aligns to
   * @param attribute correct attribute to use
   */
  createPropertyDeprecationMessage(e, s, i) {
    let n = `Beacon Warning: [${e}] will be deprecated as a prop of <${this.beaconTagName.toLowerCase()}> in a future release.`;
    return s !== fe.NO_SYNC && (n += ` Start using [${i || s}] instead to avoid future disruptions.`), n;
  }
  /**
   * Generates a console message to log when a deprecated property is used
   * and should instead use the designated slot
   * @param property the name of the property being deprecated
   * @param slot the designated slot to use instead
   */
  createPropertyDeprecationForSlotMessage(e, s) {
    return `Beacon Warning: '${e}' will be deprecated as a prop of <${this.beaconTagName.toLowerCase()}> in a future release. Start using the slot: '${s}' instead to avoid future disruptions`;
  }
  /**
   * Extend's Lit's `createProperty` method for our own uses.
   * @param name Property Name
   * @param options Options for the property
   */
  static createProperty(e, s) {
    if (s) {
      const { alternateAttributes: i, attribute: n } = s, c = Object.prototype.hasOwnProperty.call(
        s,
        "sync"
      );
      if (T.deprecatedPropertyKeys.forEach((u) => {
        Object.prototype.hasOwnProperty.call(s, u) && (this.hasDeprecatedProperties = !0);
      }), i && i.forEach((u) => {
        this.alternateAttributesMap.set(u, e);
      }), c && !s.sync) {
        const u = n != null ? n : e;
        this.alternateAttributesMap.set(
          u,
          fe.NO_SYNC
        );
      }
    }
    super.createProperty(e, s);
  }
  /**
   * This is used to return the property options of a property when given only its attribute name,
   * e.g. the property pageTitle with an attribute name of 'page-title' will have no way of accessing its options
   * directly when attempting to grab the options with 'page-title' and elementProperties.get().
   * @param name the resolved attribute name of a `@property()` decorated property
   * @returns the options passed in `@property()` e.g. `{attribute: 'attribute-name', reflect: true}`
   */
  getPropertyOptions(e) {
    var i;
    const { elementProperties: s } = this.constructor;
    return (i = s.get(e)) != null ? i : [...s.values()].find(
      (n) => n.attribute === e
    );
  }
  /**
   * @deprecated, to be removed in v5
   * Getter that returns private resolvedDeferOptions
   * @returns resolvedDeferOptions that are passed to an IntersectionObserver
   */
  getResolvedDeferOptions() {
    return this.resolvedDeferOptions;
  }
  /** callback method for the beacon-on-click event*/
  onBeaconClick() {
  }
  /** callback method for the beacon-on-keydown event*/
  onBeaconKeydown() {
  }
  /** callback method for the beacon-on-toggle event*/
  onBeaconToggle() {
  }
  /**
   * Converts space separated list prop of `defer-until` to a DeferUntil enum array
   */
  get deferList() {
    var e, s;
    return (s = (e = this.deferUntil) == null ? void 0 : e.split(" ").map((i) => i).filter((i) => !!i)) != null ? s : [];
  }
  /**
   * Logs a warning based on the slot name provided and details from the alternate slots map
   *
   * @param slotName name of the slot that has changed
   */
  slotDeprecationWarn(e) {
    const s = this.alternateSlots.get(e);
    if (s !== void 0) {
      let i;
      const n = `The '${e}' for for '${this.beaconTagName}'`;
      Object.keys(s).some((c) => c.match("alternate")) ? s.alternateAttribute ? i = `will be replaced by the element property '${s.alternateAttribute}'` : i = `will be replaced by the '${s.alternateSlots}' slot` : i = "will be removed", console.warn(
        `Beacon Deprecation Warning: ${n} ${i} in foundation@${s.version}`
      );
    }
  }
  /**
   * @deprecated, to be removed in v5
   * A setter that takes user input deferOptions and resolves them compared to existing deferOptions. Enables the setting
   * of isolated deferOptions and leaves unchanged options previously set intact.
   * @param options the defer-options object used in IntersectionObserver.
   */
  setDeferOptions(e) {
    if (!e) return;
    const s = { ...this.resolvedDeferOptions }, i = De([
      e == null ? void 0 : e.root,
      s == null ? void 0 : s.root
    ]), n = De([
      e == null ? void 0 : e.rootMargin,
      s == null ? void 0 : s.rootMargin
    ]), c = De([
      e == null ? void 0 : e.threshold,
      s == null ? void 0 : s.threshold
    ]);
    this.resolvedDeferOptions = {
      root: i instanceof Document || i instanceof Element ? i : document,
      rootMargin: typeof n == "string" ? n : T.defaultDeferOptions.rootMargin,
      threshold: Array.isArray(c) || typeof c == "number" ? c : T.defaultDeferOptions.threshold
    };
  }
  /**
   * @deprecated, to be removed in v5
   * Hides the visibility of the component. Used when component is deferred until specified condition.
   * @returns void
   */
  setDeferVisibilityStyles() {
    ut(T.safari) || (this.style.visibility = T.hidden);
  }
  /**
   * @deprecated, to be removed in v5
   * Sets the component styles to visibile. Used when component meets condition specified to defer until.
   * @returns void
   */
  removeDeferVisibilityStyles() {
    ut(T.safari) || this.style.removeProperty("visibility");
  }
  /**
   * @deprecated, to be removed in v5
   * Searches for a parent of component with defer-until attribute that is not solely defer-until="defined".
   * @returns closest lightDOM parent with [defer-until] attribute or null
   */
  getClosestDeferredParent() {
    const e = '[defer-until]:not([defer-until="defined"])', s = this.closest(
      e
    );
    if (s && ht(s))
      return s;
    const i = this.getClosestHost();
    if (i) {
      const n = i.closest(
        e
      );
      if (n && ht(n))
        return n;
    }
    return null;
  }
  /**
   * Runs in shadowDOM context. This method searches for the ShadowRoot then returns host of ShadowRoot.
   * @returns host element of this component of the shadowDOM
   */
  getClosestHost() {
    let e = this && this.parentNode;
    for (; e; ) {
      if (e instanceof ShadowRoot)
        return e.host;
      e = e.parentNode;
    }
    return null;
  }
  /**
   * @deprecated, to be removed in v5
   * Selects which deferUntil handler method to run on component.
   * @param deferUntilCriteria DeferUntil option that determines how component should defer.
   */
  selectDeferUntilHandler(e) {
    return new Promise((s) => {
      e.includes(q.VISIBLE) ? (this.setDeferVisibilityStyles(), this.deferUntilVisible().then(() => {
        this.removeDeferVisibilityStyles(), s();
      })) : e.includes(q.IDLE) ? (this.setDeferVisibilityStyles(), this.deferUntilIdle().then(() => {
        this.removeDeferVisibilityStyles(), s();
      })) : s();
    });
  }
  /**
   * @deprecated, to be removed in v5
   * Method that handles setup of deferUntil handler when deferUntil is configured locally via deferUntil prop on the component.
   */
  handleLocalDeferUntil() {
    return new Promise((e) => {
      this.deferOptions && this.setDeferOptions(this.deferOptions), this.selectDeferUntilHandler(this.deferList).then(() => e());
    });
  }
  /**
   * @deprecated, to be removed in v5
   * Method that looks for the closest element to the component with 'defer-until' attribute and either
   * applies the parent's deferUntil logic to the component immediately, if the parent is already registered as `isDeferUntilParent`,
   * or adds an eventListener to toggle parent's deferUntil logic on component once parent has emitted the beacon-event-deferred-child Event.
   * @param closestDeferredParent is the closest element to the component that has the 'defer-until' attribute set.
   */
  handleParentalDeferUntil(e) {
    return new Promise((s) => {
      if (e === null)
        s();
      else if (vs(e))
        this.selectDeferUntilHandler(e.deferList).then(
          () => s()
        );
      else {
        const i = (n) => {
          this.deferredChildEventHandler(n).then(() => {
            e.removeEventListener(
              P.DEFERRED_CHILD,
              i
            ), s();
          });
        };
        e.addEventListener(
          P.DEFERRED_CHILD,
          i
        );
      }
    });
  }
  /**
   * @deprecated, to be removed in v5
   * Now that it is deprecated the only components that will respond to deferUntil="visible"
   * are the beacon-table and its subcomponents
   */
  handleDefer() {
    return new Promise((e) => {
      if (!this.deferrable || this.motionState === "enabled")
        e();
      else if (this.deferUntil)
        this.registerAsDeferUntilParent(), this.handleLocalDeferUntil().then(() => e());
      else {
        const s = this.getClosestDeferredParent();
        s ? this.handleParentalDeferUntil(s).then(
          () => e()
        ) : e();
      }
    });
  }
  /**
   * @deprecated, to be removed in v5
   * Method that registers a component as parental component that can trigger deferUntil logic in child components. It should be placed in connectedCallback
   * of all components that need to trigger deferUntil logic in child components.
   */
  registerAsDeferUntilParent() {
    if (this.deferOptions && this.setDeferOptions(this.deferOptions), this.deferList.includes(q.VISIBLE)) {
      const e = new IntersectionObserver((s) => {
        for (const i of s)
          i.target && (this.isDeferUntilParent = !0, this.emitDeferredChild(), e.disconnect());
      }, this.getResolvedDeferOptions() || null);
      e.observe(this);
    }
  }
  /**
   * @returns the scope prefix from the beginning of the tagName.
   */
  getScopedTagPrefix() {
    const e = this.tagName.toLowerCase().split("-beacon")[0];
    return e.startsWith("beacon") ? "" : e;
  }
  /**
   * Defines this web component in the CustomElementRegistry.
   * @param tagNamePrefix lowercase string that prefixes default component tag names for scoping purposes
   */
  static registerComponent(e) {
    if (this.tagName) {
      const s = `${e ? `${e}-` : ""}${this.tagName}`;
      if (this.nestedComponents.forEach(
        (i) => i.registerComponent(e)
      ), !customElements.get(s)) {
        const i = class extends this {
        };
        Object.defineProperty(i, "name", {
          value: $s(s)
        }), customElements.define(s, i), customElements.whenDefined(s).then(() => {
          const n = new CustomEvent(P.REGISTER, {
            detail: s
          });
          document.dispatchEvent(n);
        }).catch((n) => {
          console.error(
            `Error defining Beacon Component ${s} in CustomElementsRegistry: `,
            n
          );
        });
      }
    }
  }
  static renderGlobalRootStyles() {
    V ? this.globalRootStyles.forEach(
      (e, s) => {
        if (!document.adoptedStyleSheets.find(
          (i) => i.name === `beacon-global-root-styles-${s}`
        )) {
          const i = new Te(
            `beacon-global-root-styles-${s}`,
            e.toString()
          );
          document.adoptedStyleSheets.push(i);
        }
      }
    ) : this.globalRootStyles.forEach((e, s) => {
      if (document.getElementById(`beacon-global-root-styles-${s}`))
        return;
      const i = document.createElement("template");
      i.innerHTML = `
        <style id="beacon-global-root-styles-${s}">
          ${e.toString()}
        </style>
      `;
      const n = i.content.cloneNode(!0);
      document.head.append(n);
    });
  }
  /**
   * This will return beacon tag name to scoped tag Name
   * @param tag beaconTagName
   * @returns Scoped tagName
   */
  getScopedTagName(e) {
    return e ? this.getScopedTagPrefix() ? `${this.getScopedTagPrefix()}-${e}` : e : "";
  }
  /**
   * @param event
   * @event {BeaconEvents} beacon-event-click - emits when clicked
   */
  emitClick() {
    te(this, P.CLICK, void 0, this.onBeaconClick);
  }
  /**
   * @param event
   * @event {BeaconEvents} beacon-event-keydown - emits when a keydown event would be fired
   */
  emitKeydown() {
    te(this, P.KEYDOWN, void 0, this.onBeaconKeydown);
  }
  emitToggle() {
    te(this, P.TOGGLE, void 0, this.onBeaconToggle);
  }
  /**
   * @deprecated, to be removed in v5
   * Emitter of beacon-event-deferred-child event used by components registered as deferUntilParents.
   * @param event
   * @event {BeaconEvents} beacon-event-deferred-child - signals to children of a deferUntil parent that they should behave as deferUntil components
   */
  emitDeferredChild() {
    te(this, P.DEFERRED_CHILD, {
      detail: {
        element: this,
        type: this.deferList
      }
    });
  }
  /**
   * Emits a beacon-event-keydown event as a default to mousedown handling
   * @param event
   */
  handleKeydown(e) {
    this.emitKeydown();
  }
  /**
   * Check if the component has a specific mixin applied.
   * @param name Name of the mixin to look for.
   * @returns True if the class contains that mixin.
   */
  hasMixin(e) {
    var s;
    try {
      if (!((s = this.constructor().mixins) == null ? void 0 : s.includes(e))) throw new Error(`This class does not implement ${e}.`);
      return !0;
    } catch (i) {
      return console.error(i), !1;
    }
  }
  /**
   * Check for a field with a specific value on the class.
   *
   * Useful when a mixin relies on the existance of another mixin.
   *
   * @param field Class property to check for on the mixin.
   * @param value Value of the given class field to check for.
   * @returns True if the value of the field is the same.
   */
  hasFieldAndValue(e, s) {
    try {
      if (!(e in this))
        throw new Error(`${e} does not exist on this: ${this}`);
      return this[e] === s;
    } catch (i) {
      return console.error(i), !1;
    }
  }
  /**
   * Placeholder method that collects all method functionality that is decorated with @prerender
   * and is called in connectedCallback. This method should not be overridden directly.
   * The goal is to prevent direct overrides of connectedCallback in subclasses
   */
  prerender(...e) {
  }
  /**
   * Placeholder method that collects all method functionality that is decorated with @postrender
   * and is called in firstUpdated. This method should not be overridden directly.
   * The goal is to prevent direct overrides of firstUpdated in subclasses
   */
  postrender(...e) {
  }
  /**
   * Placeholder method that collects all method functionality that is decorated with @destroy
   * and is called in disconnectedCallback. This method should not be overridden directly.
   * The goal is to prevent direct overrides of disconnectedCallback in subclasses
   */
  destroy(...e) {
  }
  /**
   * Enables or disables motion on this component.
   *
   * Looks for the closest element with `[motion-state]` to find its value and set the motion state of the component equal to that.
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/API/Element/closest Element.closest() will return the element itself if it matches the selector.
   */
  setMotionState() {
    if (this.motionState === "enabled")
      return;
    const e = this.closest("[motion-state]"), s = e == null ? void 0 : e.getAttribute("motion-state");
    s && (s === "enabled" || s === "disabled") && (this.motionState = s);
  }
  /**
   * Removes the "defined" string value from defer-until attribute while leaving in place any other subString in the attribute.
   * This is a clean-up function called in connectedCallback that enables usage of applitools UltraFastGrid with defer-until="defined"
   * components.
   */
  removeDeferUntilDefined() {
    const e = this.getAttribute("defer-until");
    if (e) {
      const i = e.split(" ").filter((u) => u), n = i.length;
      if (n === 1 && i.includes("defined") || n === 0)
        this.removeAttribute("defer-until");
      else {
        const u = i.filter((d) => d !== "defined").join(" ");
        this.setAttribute("defer-until", u);
      }
    } else this.hasAttribute("defer-until") && !e && this.removeAttribute("defer-until");
  }
  renderLightDOMStyles() {
    V ? (this.renderStyles(
      "globalLightDOMStyles",
      "beacon-global-light-DOM-styles"
    ), this.renderStyles(
      "lightDOMStyles",
      `${this.beaconTagName}-light-DOM-styles`
    )) : (this.renderStyles(
      "lightDOMStyles",
      `${this.beaconTagName}-light-DOM-styles`
    ), this.renderStyles(
      "globalLightDOMStyles",
      "beacon-global-light-DOM-styles"
    ));
  }
  /**
   * Set custom state (using ElementInternals) on a component.
   *
   * A fallback when custom state isn't supported toggles a custom attribute that matches the state.
   *
   * States can be styled in CSS without the need to reflect a property.
   *
   * element-internals-polyfill will do the work of setting fallback attributes.
   *
   * @example
   * ```css
   * :host(:state(--custom-state)),
   * :host([state--custom-state]) {
   *  rule: value;
   * }
   * ```
   */
  setState(e, s = !0) {
    this._internals ? s ? this._internals.states.add(e) : this._internals.states.delete(e) : console.error(
      `Attempted to set state ${At} on ${this.tagName} but internals are not available.`
    );
  }
  connectedCallback() {
    this.setMotionState(), this.removeDeferUntilDefined(), this.handleDefer().then(() => {
      super.connectedCallback(), Je(this, G) || (ke.setHostEventHandlerForAnalytics(this, this.version), Ae(this, G, !0)), S.renderGlobalRootStyles(), this.renderLightDOMStyles(), this.prerender();
    });
  }
  firstUpdated() {
    this.postrender(), te(this, P.ELEMENT_READY);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.destroy();
  }
}, G = new WeakMap(), S.styles = [Mt, xt, Ct], S.tagName = "", S.nestedComponents = [], S.shadowRootOptions = {
  ...K.shadowRootOptions,
  delegatesFocus: !0
}, S.alternateAttributesMap = /* @__PURE__ */ new Map(), S.hasDeprecatedProperties = !1, S.mixins = [], S.lightDOMStyles = [], S.globalLightDOMStyles = [
  gs,
  bs
], S.globalRootStyles = [ys], S);
U([
  R({ attribute: "focus-override", type: Boolean, reflect: !0 })
], k.prototype, "focusOverride");
U([
  R({ attribute: "reset-spacing", type: Boolean, reflect: !0 })
], k.prototype, "resetSpacing");
U([
  R({ attribute: "beacon-tag-name", type: String, reflect: !0 })
], k.prototype, "beaconTagName");
U([
  R({ attribute: "beacon-version", reflect: !0 })
], k.prototype, "version");
U([
  R({ attribute: "defer-until" })
], k.prototype, "deferUntil");
U([
  R({ attribute: "defer-options" })
], k.prototype, "deferOptions");
U([
  R({ attribute: "motion-state", reflect: !0 })
], k.prototype, "motionState");
U([
  At()
], k.prototype, "prefersReducedMotion");
let Is = k;
export {
  se as A,
  Is as B,
  w as E,
  X as T,
  Ts as Z,
  ds as a,
  Ps as b,
  Os as c,
  te as e,
  Pe as f,
  Z as i,
  R as n,
  At as r,
  ps as s,
  ks as u,
  is as x
};
